/*
===============================================================================================================
                                 Copyright 2022-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import { useState, useEffect } from 'react';
import getEnvVar from '@/utilities/environment-variable';
import apiClient from '@/utilities/api-client';
import portalUtilitiesManager from '@/utilities/lui-portal-utilities-manager';
import { APP_ID } from './constants';

export default function useAppAuth() {
  const hostId = getEnvVar('REACT_APP_ORGANISATION_ID');
  const [authData, setAuthData] = useState(null);
  const [error, setError] = useState(null);
  const isInWidgetMode = portalUtilitiesManager.isInIFrame();

  const permissions = [
    'auth_staff_password',
    'auth_refresh_token',
    'authmanagement_staff:password_reset',
    'authmanagement_staff:password_reset_trigger',
    'prereg:write',
    'prereg:read',
    'returns_portal_service:app:admin',
  ];

  const makeAuthRequest = async () => {
    const body = {
      grant_type: 'client_credentials',
      scope: [...permissions].join(' '),
    };

    try {
      const response = await apiClient.post(`${hostId}/auth/token`, body, {
        headers: {
          'x-request-source': APP_ID,
        },
        headersOverride: false, // do not let apiClient populate Authorization header from session storage
      });
      setAuthData(response.data);
    } catch (exception) {
      setError(true);
    }
  };

  const data = {
    authData,
    authToken: authData ? `${authData.token_type} ${authData.access_token}` : null,
    error,
  };

  useEffect(() => {
    if (!isInWidgetMode) {
      makeAuthRequest();
    }
  }, []);

  return [data];
}
